module.exports = __webpack_public_path__ + "static/media/contact.a35177b7.svg";